export const MOBILE_WEB_HOSTNAME = 'm.wavve.com'
export const PC_WEB_HOSTNAME = 'www.wavve.com'
export const API_BASE_URL = 'https://apis.wavve.com'
export const API_BASE_URL_CLOVER_FIELD = 'https://apis.wavve.com/cf'
export const API_BASE_URL_ELYSIUM = 'https://apis.wavve.com/es'
export const API_BASE_URL_FROZEN = 'https://apis.wavve.com/fz'
export const API_BASE_AZURE_URL = 'https://apis.wavve.com'
export const API_BASE_ANNEX_URL = 'https://annexapi.wavve.com'
export const API_BASE_ANNEX_AZURE_URL = 'https://annexapi.wavve.com'
export const API_BASE_ANNEXM_URL = 'https://annexm.wavve.com'
export const API_BASE_ANNEXM_AZURE_URL = 'https://annexm.wavve.com'
export const API_HAYSTACK_URL = 'https://haystack.wavve.com'
export const API_BASE_URL_STORE = 'https://store-api.wavve.com'
export const API_BASE_URL_ACCOUNT = 'https://account-api.wavve.com'
export const API_BASE_URL_PARTNER = 'https://partner.wavve.com'

// 플레이어용 도메인 (프로토콜은 붙이지 않음. 그래서 URL이 아님)
export const DOMAIN_PLAYER = 'player.wavve.com'

export const HTTP_METHOD_GET = 'get'
export const HTTP_METHOD_POST = 'post'
export const HTTP_METHOD_DELETE = 'delete'
export const HTTP_METHOD_PUT = 'put'
export const HTTP_METHOD_DEEP_LINK = 'deeplink'

export const URL_GET_ALARMS = `${API_BASE_URL}/alarms` // 수신된 알람 목록 조회
export const URL_POST_ALARMS = `${API_BASE_URL}/alarms` // 수신된 알람 전체 읽음 설정
export const URL_DELETE_ALARMS = `${API_BASE_URL}/alarms` // 수신된 알람 목록 조회

export const URL_GET_ALARMS_CONTENTS = `${API_BASE_URL}/alarms-contents` // 알람 예약 정보 목록 조회
export const URL_POST_ALARMS_CONTENTS = `${API_BASE_URL}/alarms-contents-regist` // 알람 예약
export const URL_DELETE_ALARMS_CONTENTS = `${API_BASE_URL}/alarms-contents` // 등록한 알람 예약 해제

export const URL_GET_ALARMS_NEW = `${API_BASE_URL}/alarms-new` // 수신된 알람 중 읽지 않은 알람 개수 조회
export const URL_GET_ALARMS_RECEIVER = `${API_BASE_URL}/alarms-receiver` // 알람 수신 설정 정보 조회
export const URL_POST_ALARMS_RECEIVER = `${API_BASE_URL}/alarms-receiver` // 알람 수신 설정 (종류별)
export const URL_DELETE_ALARMS_DETAIL = `${API_BASE_URL}/alarms` // 수신된 알람 중 특정 알람 삭제

export const URL_GET_CLIP_CONTENTS = `${API_BASE_URL}/clip/contents` // 클립 목록 (채널별/프로그램별/회차별/최신순/과거순)
export const URL_GET_CLIP_CONTENTS_CF = `${API_BASE_URL_CLOVER_FIELD}/clip/contents` // 클립 목록 (채널별/프로그램별/회차별/최신순/과거순)
export const URL_GET_CLIP_CONTENTS_DETAIL = `${API_BASE_URL}/clip/contents` // 특정 클립의 상세 정보
export const URL_GET_CLIP_SMR_BRAND_INFO = `${API_BASE_URL}/clip/smrbrandinfo` // SMR 브랜드 정보
export const URL_GET_CLIP_SMR_CONTENTS = `${API_BASE_URL}/clip/smrcontents` // 방송사별 브랜드별 콘텐츠 목록
export const URL_GET_CLIP_SMR_POPULAR_CONTENTS = `${API_BASE_URL}/clip/smrpopularcontents` // 추천 영상 목록

// Events
export const URL_GET_EVENTS_NOTICE = `${API_BASE_URL}/events-notice` // 이벤트 공지 목록
export const URL_GET_EVENTS_NOTICE_DETAIL = `${API_BASE_URL}/events-notice` // 이벤트 공지사항 상세
export const URL_GET_EVENTS_CONTENTS_DETAIL_BANNER = `${API_BASE_URL_CLOVER_FIELD}/events-banner/contents` // 영화/VOD 상세 이벤트 배너

export const URL_OLAP_LOG =
  'http://olaplog.smartmediarep.com/api/v1/olap/olap.sb'

// Faqs
export const URL_GET_FAQS = `${API_BASE_URL}/faqs` // FAQ 목록 조회
export const URL_GET_FAQS_DETAIL = `${API_BASE_URL}/faqs` // FAQ 내용 조회
export const URL_GET_FAQS_RECOMMEND = `${API_BASE_URL}/faqsrecommend` // 자주 묻는 질문 목록

// Filters
export const URL_GET_FILTERS = `${API_BASE_URL}/filters` // 전체 API에서 사용하는 필터용 목록[복합]

// Guid
export const URL_GET_GUID_ISSUE = `${API_BASE_URL}/guid/issue` // GUID 발급
// Homeshopping
export const URL_GET_HOMESHOPPING = `${API_BASE_URL}/homeshopping` // 홈쇼핑 채널 정보
export const URL_GET_HOMESHOPPING_ADD_INFO = `${API_BASE_URL}/homeshopping/addinfo` // 홈쇼핑 채널 정보

// IP
export const URL_GET_IP = `${API_BASE_URL}/ip` // 접속 기기의 외부 IP 조회

// Live
export const URL_GET_LIVE_ALL_CHANNELS_CF = `${API_BASE_URL_CLOVER_FIELD}/live/all-channels` // Live 채널 목록
export const URL_GET_LIVE_RECOMMEND_CHANNELS_CF = `${API_BASE_URL_CLOVER_FIELD}/live/recommend-channels` // Live 채널 목록
export const URL_GET_LIVE_ALL_CHANNELS = `${API_BASE_URL}/live/all-channels` // Live 채널 목록
export const URL_GET_LIVE_CHANNELS_DETAIL = `${API_BASE_URL}/live/channels` // Live 채널 상세정보
export const URL_GET_LIVE_EPGS = `${API_BASE_URL}/live/epgs` // 전체 채널 편성표 목록
export const URL_GET_LIVE_EPGS_CHANNELS = `${API_BASE_URL}/live/epgs/channels` // 채널 편성표 목록
export const URL_GET_LIVE_EPGS_CHANNELS_DETAIL = `${API_BASE_URL}/live/epgs/channels` // 채널 편성표 목록
export const URL_GET_LIVE_GENRE_CHANNELS = `${API_BASE_URL}/live/genrechannels` // Live 장르별 채널 목록 전체

export const URL_GET_SAME_TIME_CHANNELS = `${API_BASE_URL_CLOVER_FIELD}/live/sametimegenrechannels`

export const URL_GET_LIVE_POPULAR_CHANNELS = `${API_BASE_URL}/live/popular-channels` // Live 채널 목록
// Profiles
export const URL_GET_PROFILES = `${API_BASE_URL}/profiles` // 해당 계정에 속한 사용가능한 프로필 리스트
export const URL_GET_PROFILES_IMAGES = `${API_BASE_URL}/profiles-images` // 프로필 이미지 변경 시 이미지 목록
export const URL_GET_PROFILES_DETAIL = `${API_BASE_URL}/profiles` // 프로필 상세 정보
export const URL_POST_PROFILES_DETAIL = `${API_BASE_URL}/profiles` // 프로필 정보 수정

// User
export const URL_GET_USER = `${API_BASE_URL}/user` // 특정 사용자의 회원정보
export const URL_POST_USER_PURCHASE_CANCEL = `${API_BASE_URL}/user/purchase/cancel` // 해지 사유 전송
export const URL_GET_USER_QNA = `${API_BASE_URL}/user/qna` // 특정 사용자의 1:1 문의 답변 내역 목록
export const URL_GET_USER_QNA_DETAIL = `${API_BASE_URL}/user/qna` // 특정 사용자의 1:1 문의 답변 내역
export const URL_DELETE_USER_QNA = `${API_BASE_URL}/user/qna` // 특정 사용자의 1:1문의 비노출

// Movie
export const URL_GET_MOVIE_CONTENTS = `${API_BASE_URL}/movie/contents` // 영화 전체 목록
export const URL_GET_MOVIE_CONTENTS_DETAIL = `${API_BASE_URL_FROZEN}/movie/contents` // 영화 상세 정보
export const URL_GET_MOVIE_RELATED_CONTENTS = `${API_BASE_URL_FROZEN}/movie/related` // 관련 movie 콘텐츠 목록 (신규 api)
export const URL_GET_MOVIE_SERIES_CONTENTS = `${API_BASE_URL_FROZEN}/movie/series` // 관련 movie 콘텐츠 목록

// Multisections
export const URL_GET_MULTISECTIONS = `${API_BASE_URL}/multisections` // 멀티 콘텐츠 목록 (섹션별)

// Mycoin
export const URL_GET_MYCOIN_LIST_CHARGED = `${API_BASE_URL}/mycoin/list/charged` // 적립 코인 목록
export const URL_GET_MYCOIN_LIST_EXPIRED = `${API_BASE_URL}/mycoin/list/expired` // 사용완료/만료 코인 목록
export const URL_GET_MYCOIN_SUMMARY = `${API_BASE_URL}/mycoin/summary` // 사용자 코인 요약 정보

// Mycoupon
export const URL_POST_MYCOUPONS_ACTIVATE = `${API_BASE_URL}/mycoupons/activate` // 보유 쿠폰 활성화
export const URL_GET_MYCOUPONS_LIST = `${API_BASE_URL}/mycoupons/list` // 보유/사용한 쿠폰 목록
export const URL_POST_MYCOUPONS_REGISTER = `${API_BASE_URL}/mycoupons/register` // 쿠폰 등록

// Mypurchase
export const URL_DELETE_MYPURCHASE_CONTENTS = `${API_BASE_URL}/mypurchase/contents` // 구매한 상품 목록 숨김
export const URL_GET_MYPURCHASE_CONTENTS_ITEM = `${API_BASE_URL}/mypurchase/contents/item` // 구매한 단건 콘텐츠 목록
export const URL_GET_MYPURCHASE_CONTENTS_PACKAGE = `${API_BASE_URL}/mypurchase/contents/package` // 구매한 패키지 목록
export const URL_GET_MYPURCHASE_PASS_CANCEL = `${API_BASE_URL}/mypurchase/pass/cancel` // 자동결제 해지 시 프로모션 대상 여부를 확인함
export const URL_POST_MYPURCHASE_PASS_CANCEL = `${API_BASE_URL}/mypurchase/pass/cancel` // 자동결제 상품 해지 / 해지 복원
export const URL_POST_MYPURCHASE_PASS_EVENT = `${API_BASE_URL}/mypurchase/pass/event` // 해지 이벤트
export const URL_GET_MYPURCHASE_PASS_PROMOTION = `${API_BASE_URL}/mypurchase/pass/promotion` // 해지 이벤트
export const URL_GET_MYPURCHASE_PASS_PROMOTION_CONTINUE = `${API_BASE_URL}/mypurchase/pass/promotion/continue` // 해지 취소 이벤트
export const URL_GET_MYPURCHASE_PRODUCTS = `${API_BASE_URL}/mypurchase/products` // 구매한 상품 목록
export const URL_DELETE_MYPURCHASE_PRODUCTS = `${API_BASE_URL}/mypurchase/products` // 구매 상품 비노출
export const URL_ALL_DELETE_MYPURCHASE_PACKAGE = `${API_BASE_URL_CLOVER_FIELD}/mypurchase/contents/allpackage` // 패키지 전체 삭제
export const URL_ALL_DELETE_PURCHASE_VOUCHER = `${API_BASE_URL_CLOVER_FIELD}/mypurchase/contents/allitem`
export const URL_GET_CHECK_UNSUBSCRIBE_ACTION = `${API_BASE_URL_STORE}/v1/check-unsubscribe-action`
export const URL_POST_PROMOTION_RECEIVE_UNSUBSCRIBE_OFFER = `${API_BASE_URL_STORE}/v1/promotion/receive-unsubscribe-offer`
export const URL_GET_CHECK_RESUBSCRIBE_ACTION = `${API_BASE_URL_STORE}/v1/check-resubscribe-action`
// My
export const URL_GET_MY_SUMMARY = `${API_BASE_URL}/my/summary` // LNB 메뉴 중단 표시용 API (PC는 마이페이지 상단)

// Myview
export const URL_GET_MYVIEW_CONTENTS = `${API_BASE_URL}/myview/contents` // 사용자의 시청 콘텐츠 목록
export const URL_DELETE_MYVIEW_CONTENTS = `${API_BASE_URL_CLOVER_FIELD}/myview/contents` // 시청 이력 삭제
export const URL_ALL_DELETE_MYVIEW_CONTENTS = `${API_BASE_URL_CLOVER_FIELD}/myview/contents-all` // 시청 이력 전체삭제
export const URL_ALL_DELETE_DOWNLOAD = `${API_BASE_URL_CLOVER_FIELD}/downloads/user` // 시청 이력 전체삭제

// Uiservice
export const URL_GET_UISERVICE_BANNER_MULTI = `${API_BASE_URL}/uiservice/banner/multi` // 복수 배너 목록
export const URL_GET_UISERVICE_BANNER_SINGLE = `${API_BASE_URL_CLOVER_FIELD}/uiservice/banner/single` // 단일 배너 목록
export const URL_GET_UISERVICE_NOTICES = `${API_BASE_URL}/uiservice/notices` // 공지사항 목록
export const URL_GET_UISERVICE_ZZIM = `${API_BASE_URL}/uiservice/zzim` // UI 특화 기능: 사용자별 좋아요 한 콘텐츠

// Notices
export const URL_GET_NOTICES = `${API_BASE_URL}/notices` // 공지사항 목록
export const URL_GET_NOTICES_DETAIL = `${API_BASE_URL}/notices` // 공지사항 상세
export const URL_GET_NOTICES_COMPANY_INFO_BOARD = `${API_BASE_URL}/companyinfoboard` // 회사 소개 게시판
export const URL_GET_NOTICES_COMPANY_INFO_BOARD_DETAIL = `${API_BASE_URL}/companyinfoboard` // 회사소개 상세

// Pooqzone
export const URL_GET_POOQZONE_CHECK = `${API_BASE_URL}/pooqzone` // 웨이브온 체크
export const URL_GET_POOQZONE_ADULT = `${API_BASE_URL}/pooqzone/adultcertification` // 웨이브온 성인 체크
export const URL_POST_POOQZONE_LOGIN = `${API_BASE_URL}/pooqzone/login` // 웨이브온 크레덴셜 발행

// Purchase
export const URL_GET_PURCHASE_PRODUCT_CONTENTS = `${API_BASE_URL}/purchase/product-contents` // 상품 콘텐츠 리스트 [복합]
export const URL_GET_PURCHASE_PRODUCTS = `${API_BASE_URL_CLOVER_FIELD}/purchase/newproducts` // 특정 콘텐츠에 대해 구매가능한 상품 목록
export const URL_GET_PURCHASE_PRODUCTS_UPSELL = `${API_BASE_URL}/purchase/products/upsell` // 특정 콘텐츠에 대해 구매가능한 상품 목록

// Recommendation
export const URL_GET_RECOMMENDATION_MOVIE = `${API_BASE_URL}/recommendation/movie` // 영화 콘텐츠 상세화면 추천용 멀티 콘텐츠 목록
export const URL_GET_RECOMMENDATION_VOD = `${API_BASE_URL}/recommendation/vod` // BROADCAST 콘텐츠 상세화면 추천용 멀티 콘텐츠 목록

// Search
export const URL_GET_SEARCH = `${API_BASE_URL_FROZEN}/search/customer` // 검색결과 목록[복합]
export const URL_GET_SEARCH_MULTI_SECTION = `${API_BASE_URL_FROZEN}/search`
export const URL_GET_SEARCH_LIST = `${API_BASE_URL_FROZEN}/search/list.js`
export const URL_GET_SEARCH_FAQ = `${API_BASE_URL_FROZEN}/search/faq` // FAQ 검색
export const URL_GET_SEARCH_INSTANCE_KEYWORDS = `${API_BASE_URL_FROZEN}/search/instance/keywords` // 자동완성 검색 키워드 목록
export const URL_GET_SEARCH_NOTICE = `${API_BASE_URL_FROZEN}/search/notices` // 공지사항 검색
export const URL_GET_SEARCH_POPULAR_KEYWORDS = `${API_BASE_URL}/search/popular/keywords` // 인기 검색어 목록
export const URL_GET_SEARCH_RECOMMEND_KEYWORDS = `${API_BASE_URL}/search/recommend/keywords` // 추천 검색어 목록
export const URL_GET_SEARCH_RECOMMEND_CONTENTS = `${API_BASE_URL_FROZEN}/search/recommend`
export const URL_GET_SEARCH_POPULAR_CONTENTS = `${API_BASE_URL_FROZEN}/search/popular/keyword`
export const URL_POST_TAG_SEARCH = `${API_BASE_URL}/tagsearch` // 태그 검색결과 목록[복합]
export const URL_POST_TAG_SEARCH_CF = `${API_BASE_URL_FROZEN}/tagsearch/list.js`
export const URL_POST_TAG_SEARCH_CF_NEW = `${API_BASE_URL_FROZEN}/tagsearch`

export const URL_GET_SEARCH_RECOMMEND_LIST = `${API_BASE_URL_FROZEN}/search/recommend/searchkeywords`

// Streaming
export const URL_GET_STREAMING = `${API_BASE_URL_FROZEN}/streaming` // 재생관련 정보 (스트리밍 / 다운로드 url 발급)

// Tags
export const URL_GET_TAGS_GROUPS = `${API_BASE_URL}/tags/groups` // 태그 검색 초기화면에서 사용하는 태그 목록
export const URL_TAGS_LIST = `${API_BASE_URL}/tags/list` // 검색결과 상단의 태그 목록

// Terms
export const URL_GET_TERMS = `${API_BASE_URL}/terms` // 약관 및 정책

// Themes
export const URL_GET_THEMES = `${API_BASE_URL}/themes` // 테마 목록
export const URL_GET_THEMES_CONTENTS = `${API_BASE_URL}/themes-contents` // 테마 콘텐츠 리스트[복합]
export const URL_GET_THEMES_LIST = `${API_BASE_URL}/themes-list` // 테마 목록 (메뉴별)
export const URL_GET_THEMES_RELATED = `${API_BASE_URL}/themes-related` // 특정 콘텐츠가 포함된 테마 목록
export const URL_GET_THEMES_DETAIL = `${API_BASE_URL}/themes` // 테마 상세

// BROADCAST
export const URL_GET_VOD_LANDING_INFO = `${API_BASE_URL_FROZEN}/vod/programs/landing` // VOD 랜딩 인포 조회
export const URL_GET_VOD_ALLPROGRAMS = `${API_BASE_URL}/vod/allprograms` // BROADCAST 프로그램 전체 목록 조회
export const URL_GET_VOD_CONTENTS_DETAIL = `${API_BASE_URL_FROZEN}/vod/contents-detail` // 특정 BROADCAST 콘텐츠 (회차) 상세 정보
export const URL_GET_VOD_NEW_CONTENTS = `${API_BASE_URL}/vod/newcontents` // BROADCAST 전체 콘텐츠 목록
export const URL_GET_VOD_POPULAR_CONTENTS = `${API_BASE_URL}/vod/popularcontents` // BROADCAST 인기 콘텐츠 목록
export const URL_GET_VOD_POPULARPROGRAMS = `${API_BASE_URL}/vod/popularprograms` // BROADCAST 프로그램 인기 목록 조회
export const URL_GET_VOD_PROGRAMS_CONTENTID = `${API_BASE_URL}/vod/programs-contentid` // 특정 프로그램 기준의 재생할 회차 contentid 받기
export const URL_GET_VOD_PROGRAMS_CONTENTS = `${API_BASE_URL_FROZEN}/vod/programs-contents` // 특정 프로그램 콘텐츠(회차) 목록
export const URL_GET_VOD_PROGRAMS_POPULAR_CONTENTS = `${API_BASE_URL}/vod/programs-popularcontents` // 특정 프로그램의 인기 콘텐츠(회차) 목록
export const URL_GET_VOD_RELATED_CONTENTS = `${API_BASE_URL_FROZEN}/vod/programs` // BROADCAST 연관 콘텐츠 목록 (신규 api) 현재 연관 콘텐츠/ 에피소드 콘텐츠 가 동일힌 상수 path 를 가지고 있으나 호출 시 path variable 로 url 이 다름 추후 상수를 하나로 통일할 지 논의 필요 (현재는 가독성을 위해 분리해 )
export const URL_GET_VOD_EPISODE_LIST = `${API_BASE_URL_FROZEN}/vod/programs` // BROADCAST 전체 콘텐츠 목록 (신규 api) 현재 연관 콘텐츠/ 에피소드 콘텐츠 가 동일힌 상수 path 를 가지고 있으나 호출 시 path variable 로 url 이 다름 추후 상수를 하나로 통일할 지 논의 필요 (현재는 가독성을 위해 분리해 둠)

export const URL_GET_CONTENT_RECOMMEND_LIST = `${API_BASE_AZURE_URL}/v1/multiband`

// Zzim
export const URL_GET_ZZIM_CONTENTS = `${API_BASE_URL}/zzim/contents` // 사용자의 선호채널(live) / 찜 콘텐츠 목록[복합]
export const URL_DELETE_ZZIM_CONTENTS = `${API_BASE_URL}/zzim/contents` // 사용자의 선호채널(live) / 찜 콘텐츠 삭제
export const URL_POST_ZZIM_DETAIL = `${API_BASE_URL}/zzim/contents` // 사용자의 선호채널(live) / 찜 콘텐츠 등록
export const URL_GET_ZZIM_DETAIL = `${API_BASE_URL}/zzim/contents` // 사용자의 선호에디터픽 확인
export const URL_POST_ZZIM_BASEBALL = `${API_BASE_URL}/dp/baseball/alarms`
export const URL_DELETE_ZZIM_BASEBALL = `${API_BASE_URL}/dp/baseball/alarms`
// DeepLink
export const URL_GET_URL_FROM_UI_CODE = `${API_BASE_AZURE_URL}/cf/deeplink`
export const URL_KBO_DAILY_SCHEDULE = `${API_BASE_ANNEX_URL}/skb/baseball/teamcalendarlist-band`
// Login / Logout
export const URL_POST_LOGIN = `${API_BASE_URL_ACCOUNT}/v0.9/signin/wavve` // 로그인
export const URL_POST_LOGOUT = `${API_BASE_URL_ACCOUNT}/v0.9/logout` // 로그아웃
export const URL_GET_TID = `${API_BASE_URL}/user/tid/auth`
export const URL_CATEGORY_LIST = `${API_BASE_URL_CLOVER_FIELD}/filters`

// 성인 정책
export const URL_GET_ADULT_VERIFICATION_STATUS = `${API_BASE_URL}/user/pin/adult`
export const URL_POST_ADULT_OTT = `${API_BASE_URL}/user/pin/adult/ott`
export const URL_POST_ADULT_CONFIRM = `${API_BASE_URL}/user/pin/adult/confirm`

// baseball
export const URL_GET_GAME_CONDITION_LIST = `${API_BASE_ANNEX_URL}/skb/baseball/gameconditionlist`
export const URL_GET_STADIUM_CONDITION_LIST = `${API_BASE_ANNEX_URL}/skb/baseball/stadiumconditionlist`
export const URL_GET_TEXT_RELAY = `${API_BASE_ANNEX_URL}/skb/baseball/cachebaseballtextrelaylist`
export const URL_GET_TEXT_RELAY_CONVERT = `${API_BASE_ANNEXM_URL}/api/sport/baseball/relay/text`
export const URL_GET_HIGHLIGHT_PLAYER_LIST = `${API_BASE_URL}/dp/vod/scene`
export const URL_GET_HIGHLIGHT_CONTENTS = `${API_BASE_URL}/dp/vod/contents`
export const URL_GET_GAME_RECORD_LIST = `${API_BASE_ANNEX_URL}/skb/baseball/baseballrecordlist`
export const URL_GET_MONTHLY_GAME_RESULT = `${API_BASE_ANNEX_URL}/skb/baseball/teammonthlycalendarlist`
export const URL_GET_TEAM_LATELY_GAME_DATE = `${API_BASE_ANNEX_URL}/skb/baseball/teamlatelygamedate`

export const URL_GET_PERMISSION_FOR_CONTENT = `${API_BASE_URL}/getpermissionforcontent`
export const URL_GET_PROGRAM_NOTICE = `${API_BASE_AZURE_URL}/es/notice/contents`

export const URL_GET_PROFILES_ELYSIUM = `${API_BASE_URL_ELYSIUM}/profiles`
export const URL_POST_USER_PROFILE_DETAIL_ELYSIUM = `${API_BASE_URL_ELYSIUM}/profiles`
export const URL_GET_PROFILE_IMAGE_LIST_ELYSIUM = `${API_BASE_URL_ELYSIUM}/profiles-images`

export const URL_GET_KNOCK = `${API_BASE_AZURE_URL}/knock`
export const URL_PUT_PROMOTION_USER = `${API_BASE_AZURE_URL}/promotion/user`

export const URL_GET_SALTED_HASH = `${API_BASE_URL}/user/hash`
export const URL_GET_VOUCHER = `${API_BASE_AZURE_URL}/passes/v1/service/wavve/pc`
export const AWS_WHITE_LIST = [
  // login
  { path: '/login', method: HTTP_METHOD_POST },
  { path: '/logout', method: HTTP_METHOD_POST },
  // profile
  { path: '/profiles', method: HTTP_METHOD_GET },
  { path: '/profiles-images', method: HTTP_METHOD_GET },
  { path: '/profiles/{path}', method: HTTP_METHOD_GET },
  { path: '/profiles/{path}', method: HTTP_METHOD_POST },
  // user
  { path: '/user', method: HTTP_METHOD_GET },
  { path: '/user/pin/adult', method: HTTP_METHOD_GET },
  { path: '/user/pin/adult/confirm', method: HTTP_METHOD_POST },
  { path: '/user/pin/adult/ott', method: HTTP_METHOD_POST },
  { path: '/user/purchase/cancel', method: HTTP_METHOD_POST },
  { path: '/user/push', method: HTTP_METHOD_GET },
  { path: '/user/push', method: HTTP_METHOD_POST },
  { path: '/user/qna', method: HTTP_METHOD_GET },
  { path: '/user/qna', method: HTTP_METHOD_DELETE },
  { path: '/user/qna/{path}', method: HTTP_METHOD_GET },
  { path: '/user/tid/auth', method: HTTP_METHOD_GET },
  // pooqzone
  { path: '/pooqzone', method: HTTP_METHOD_GET },
  { path: '/pooqzone/adultcertification', method: HTTP_METHOD_GET },
  { path: '/pooqzone/connectionstatus', method: HTTP_METHOD_GET },
  { path: '/pooqzone/login', method: HTTP_METHOD_POST },
  // 기존
  { path: '/my/summary', method: HTTP_METHOD_GET },
  { path: '/mypurchase/pass/event', method: HTTP_METHOD_POST },
  { path: '/mypurchase/pass/cancel', method: HTTP_METHOD_GET },
  { path: '/mypurchase/pass/cancel', method: HTTP_METHOD_POST },
  { path: '/mypurchase/pass/promotion', method: HTTP_METHOD_GET },
  { path: '/mypurchase/pass/promotion/continue', method: HTTP_METHOD_GET },
  { path: '/mypurchase/products', method: HTTP_METHOD_GET },
  { path: '/mycoupons/register/{path}', method: HTTP_METHOD_POST },
  { path: '/mycoin/summary', method: HTTP_METHOD_GET },
  { path: '/mycoupons/list', method: HTTP_METHOD_GET },
  { path: '/mycoin/list/charged', method: HTTP_METHOD_GET },
  { path: '/mycoupons/activate/{path}', method: HTTP_METHOD_POST },
  { path: '/mycoin/list/expired', method: HTTP_METHOD_GET },
]
